export var RangeFieldActionKind;
(function (RangeFieldActionKind) {
    RangeFieldActionKind[RangeFieldActionKind["SET_MIN"] = 0] = "SET_MIN";
    RangeFieldActionKind[RangeFieldActionKind["SET_MAX"] = 1] = "SET_MAX";
})(RangeFieldActionKind || (RangeFieldActionKind = {}));
function isNumberOrUndefined(payload) {
    return ((typeof payload === 'number' && !Number.isNaN(payload)) || payload == null);
}
export function RangeFieldReducer(state, action) {
    if (!isNumberOrUndefined(action.payload)) {
        return state;
    }
    switch (action.type) {
        case RangeFieldActionKind.SET_MIN: {
            if (state.min !== action.payload) {
                return {
                    ...state,
                    min: action.payload,
                };
            }
            return state;
        }
        case RangeFieldActionKind.SET_MAX: {
            if (state.max !== action.payload) {
                return {
                    ...state,
                    max: action.payload,
                };
            }
            return state;
        }
        default:
            return state;
    }
}
//# sourceMappingURL=RangeFieldReducer.js.map